class SaleCountdownTimer extends HTMLElement {
  connectedCallback() {
    const endDatetime = this.dataset.endDatetime;
    this.endTime = new Date(endDatetime).getTime();
    this.hideWhenZero = this.dataset.hideWhenZero === 'true';

    this.daysEl = this.querySelector('[data-days]');
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');

    if (Number.isNaN(this.endTime)) return;

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remainingMs = this.endTime - Date.now();

    if (remainingMs <= 0) {
      if (this.hideWhenZero) {
        this.classList.add('sale-countdown__timer--hidden');
      } else {
        this.render(0, 0, 0, 0);
      }
      clearInterval(this.interval);
      return;
    }

    const totalSeconds = Math.floor(remainingMs / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.render(days, hours, minutes, seconds);
  }

  render(days, hours, minutes, seconds) {
    this.daysEl.textContent = String(days).padStart(2, '0');
    this.hoursEl.textContent = String(hours).padStart(2, '0');
    this.minutesEl.textContent = String(minutes).padStart(2, '0');
    this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }
}

if (!customElements.get('sale-countdown-timer')) {
  customElements.define('sale-countdown-timer', SaleCountdownTimer);
}
